import { render, staticRenderFns } from "./iconImpressum.vue?vue&type=template&id=1e2ccf67"
import script from "./iconImpressum.vue?vue&type=script&lang=js"
export * from "./iconImpressum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports